import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, getId, createItem, updateItem, deleteById } from "./menuAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk("menu/fetchData", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchMenu = createAsyncThunk("menu/fetchMenu", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchId = createAsyncThunk("menu/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdNoloading = createAsyncThunk(
  "menu/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);
export const addItem = createAsyncThunk("menu/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("menu/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "menu/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchMenu.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = menuSlice.actions;

export const selectData = (state) => state.menu.data;
export const selectDataMenu = (state) => state.menu.data;
export const selectId = (state) => state.menu.dataId;
export const selectLoading = (state) => state.menu.loading;
export const selectError = (state) => state.menu.error;
export const selectPageNo = (state) => state.menu.pageNo;
export const selectPageSize = (state) => state.menu.pageSize;
export const selectTotalRecord = (state) => state.menu.totalRecord;
export const selectSelected = (state) => state.menu.selected;
export const selectResult = (state) => state.menu.result;

export default menuSlice.reducer;
